var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 9,
    viewBox: "0 0 25 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62526 8.25825H4.50494L2.91495 2.19237C2.83949 1.91334 2.67925 1.66667 2.44354 1.5504C1.85531 1.25823 1.20712 1.0257 0.5 0.908431V0.674895H3.91567C4.38708 0.674895 4.74064 1.0257 4.79957 1.43313L5.62454 5.80865L7.74383 0.674895H9.80522L6.62526 8.25825ZM10.9838 8.25825H8.98129L10.6302 0.674895H12.6327L10.9838 8.25825ZM15.2234 2.77571C15.2823 2.36728 15.6359 2.13374 16.0483 2.13374C16.6965 2.07511 17.4026 2.19238 17.9919 2.48354L18.3454 0.85081C17.7562 0.617274 17.108 0.5 16.5198 0.5C14.5762 0.5 13.162 1.55041 13.162 3.00824C13.162 4.11728 14.1637 4.69961 14.8708 5.05042C15.6359 5.40021 15.9305 5.63375 15.8716 5.98355C15.8716 6.50825 15.2823 6.74178 14.6941 6.74178C13.9869 6.74178 13.2798 6.56688 12.6327 6.27471L12.2791 7.90845C12.9862 8.19962 13.7512 8.31689 14.4584 8.31689C16.6376 8.37451 17.9919 7.32512 17.9919 5.75001C17.9919 3.76647 15.2234 3.65021 15.2234 2.77571ZM25 8.25825L23.41 0.674895H21.7022C21.3486 0.674895 20.9951 0.908431 20.8772 1.25823L17.9329 8.25825H19.9943L20.4058 7.15021H22.9386L23.1743 8.25825H25ZM21.9968 2.71708L22.585 5.57512H20.9361L21.9968 2.71708Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visa-logo.efb48266d871d6941a02d5f6b4ffda44.svg";
export { ForwardRef as ReactComponent };